import React, { useState, useEffect } from 'react';
import { array, func } from 'prop-types';

import { get, isEmpty } from 'lodash';

import { connect } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';

import Button from '@material-ui/core/Button';
import BobConfirmButton from './../../../components/BobConfirmButton';
import BobLoadingMask from '../../../components/BobLoadingMask';

import * as ArchitectActions from '../../../actions/architectActions';
import * as ApplicationMessageActions from '../../../actions/applicationMessageActions';
import * as SiteActions from '../../../actions/siteActions';
import * as UiActions from '../../../actions/uiActions';

import classes from '../CreateEntityModal.module.css';

const defaultManufacturer = '00000000-0000-0000-0000-000000000000';

const EquipmentValidationSchema = Yup.object().shape({
    client: Yup.string()
        .required(),
    site: Yup.string()
        .required(),
    name: Yup.string()
        .required(),
    equipmentType: Yup.string()
        .required(),
    manufacturer: Yup.string(),
    modelNumber:  Yup.string(),
    serialNumber: Yup.string()
});

const SystemValidationSchema = Yup.object().shape({
    client: Yup.string()
        .required(),
    site: Yup.string()
        .required(),
    name: Yup.string()
        .required(),
    systemType: Yup.string()
        .required()
});

const CreateEquipmentOrSystemModal = ({
    activeNavClient,
    activeNavSite,
    bobLoading,
    clearErrors,
    clients,
    close,
    equipmentTypes,
    equipment,
    errors,
    fetchClientSites,
    fetchEquipmentListAfterCreate,
    fetchSystemListAfterCreate,
    fetchSystemsBySiteId,
    fetchEquipmentsBySiteId,
    fetchEquipmentByEquipmentId,
    fetchSystemBySystemId,
    fetchBobSystemsByEquipmentId,
    fetchBobEquipmentBySystemId,
    filteredSystems,
    filteredEquipment,
    isEdit,
    isLoading,
    isFromSystemTab,
    manufacturers,
    navClients,
    selectedClient,
    selectedSite,
    systemTypes,
    system,
    sites,
    toggleLoading,
    targetNavCompany,
    targetNavClient,
    targetNavSite,
    onClose,
    ...props
}) => {
    const [clientSelected, setClientSelected] = useState(false);
    const [isEquipmentCreate, setIsEquipmentCreate] = useState(isFromSystemTab ? false : true);
    const [equipments, setEquipments] = useState([]);
    const [systems, setSystems] = useState([]);
    const [initialValues, setInitialValues] = useState({
        client:        !isEmpty(activeNavClient) ? activeNavClient.id : '',
        site:          !isEmpty(activeNavSite) ? activeNavSite.id : '',
        name:          '',
        equipmentType: '',
        manufacturer:  '',
        modelNumber:   '',
        serialNumber:  '',
        systemType:    '',
        equipments:    [],
        systems:       []
    });

    useEffect(() => {
        const init = async () => {
            if (!isEmpty(targetNavClient) && !isEmpty(targetNavSite)) {
                await fetchEquipmentsOrSystems(targetNavSite.id, isEquipmentCreate);
            }
            if (!isEmpty(targetNavClient)) {
                setClientSelected(true);
    
                toggleLoading(false);
                await fetchClientSites(targetNavClient.id);
            }
        };
        init();
    }, []);

    useEffect(() => {
        if ( equipment && equipment.equipmentId ) {
            fetchEquipmentByEquipmentId(equipment.equipmentId).then(async equipmentData => {
                // await fetchBobSystemsByEquipmentId(equipment.siteId, equipment.equipmentId);
                await fetchClientSites(equipment.clientId);
                await fetchEquipmentsOrSystems(equipment.siteId, isEquipmentCreate);
                setInitialValues({
                    ...initialValues,
                    client:        get(equipment, 'clientId', ''),
                    site:          get(equipment, 'siteId', ''),
                    name:          get(equipmentData, 'name', ''),
                    equipmentType: get(equipmentData, 'equipmentType.id', ''),
                    manufacturer:  handleManufacturer(get(equipmentData, 'manufacturer.id', '')),
                    modelNumber:   get(equipmentData, 'model', ''),
                    serialNumber:  get(equipmentData, 'serialNumber', '')
                });
            });
        }
        
        if ( system && system.systemId ) {
            fetchSystemBySystemId(system.systemId).then(async systemData => {
                // await fetchBobEquipmentBySystemId(system.siteId);
                await fetchClientSites(system.clientId);
                await fetchEquipmentsOrSystems(system.siteId, isEquipmentCreate);
                setInitialValues({
                    ...initialValues,
                    client:     get(system, 'clientId', ''),
                    site:       get(system, 'siteId', ''),
                    name:       get(systemData, 'name', ''),
                    systemType: get(systemData, 'systemType.id', '')
                });
            });
        }
    }, []);

    // useEffect(() => {
    //     let equipments = [];
    //     if (!isEmpty(filteredEquipment)) {
    //         // eslint-disable-next-line array-callback-return
    //         filteredEquipment.map(item => {
    //             equipments.push(item.name);
    //         });
    //         setInitialValues({...initialValues, equipments});
    //     }
    // }, [filteredEquipment]);

    // useEffect(() => {
    //     if (!isEmpty(filteredSystems)) {
    //         let systems = [];
    //         // eslint-disable-next-line array-callback-return
    //         filteredSystems.map(item => {
    //             systems.push(item.name);
    //         });
    //         setInitialValues({...initialValues, systems});
    //     }
    // }, [filteredSystems]);


    const formik = useFormik({
        initialValues:      initialValues,
        validationSchema:   isEquipmentCreate ? EquipmentValidationSchema : SystemValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            const {
                createEquipment,
                createSystem,
                createEquipmentSystem,
                createSystemEquipment,
                updateEquipment,
                updateSystem
            } = props;

            let isCreated;
            let isUpdated;

            const siteId = values.site;
            
            // changing payload based on Equipment or System
            const body =  isEquipmentCreate ? {
                name:            values.name,
                equipmentTypeId: values.equipmentType,
                model:           values.modelNumber,
                serialNumber:    values.serialNumber
            } : {
                name:         values.name,
                systemTypeId: values.systemType
            };
            
            if (isEquipmentCreate && !isEmpty(values.manufacturer)) body.equipmentManufacturerId = values.manufacturer;

            clearErrors();
            setSubmitting(true);

            const companyInfo = {
                companyId: targetNavCompany.id
            };
            
            try {
                if (!isLoading) {
                    toggleLoading(true);
                    if (isEdit) {
                        if (isFromSystemTab) {
                            // update system
                            isUpdated = await updateSystem(system.systemId, companyInfo, body);
                        } else {
                            // update equipment
                            isUpdated = await updateEquipment(equipment.equipmentId, companyInfo, body);
                        }
                    } else {
                        // changing action based on Equipment or System
                        isCreated =  isEquipmentCreate ? await createEquipment(siteId, body) : await createSystem(siteId, body);
                    }
                }

                if (isCreated && isCreated.id && !isEdit) {
                    const entityId = isCreated.id;
                    // Link newly created equipment to list of system 
                    if (isEquipmentCreate) {
                        if (formik.values.systems && !isEmpty(formik.values.systems)) {
                            let systemIdlist = systems.filter(f => formik.values.systems.includes(f.name)).map(type => type.id);
                            isCreated = await createEquipmentSystem(
                                entityId,
                                siteId,
                                systemIdlist
                            );
                        }
                    } else {
                        // Link newly created system to list of equipment 
                        if ( formik.values.equipments && !isEmpty(formik.values.equipments)) {
                            let equipmentIdlist = equipments.filter(f => formik.values.equipments.includes(f.name)).map(type => type.id);
                            isCreated = await createSystemEquipment(
                                entityId,
                                siteId,
                                equipmentIdlist
                            );
                        }
                    }
                }
                
                if (isCreated || isUpdated) {
                    setSubmitting(false);
                    toggleLoading(false);

                    handleClose(body);
                } else {
                    setSubmitting(false);
                    toggleLoading(false);
                }
            } catch (error) {
                setSubmitting(false);
            }
        }
    });

    useEffect(() => {
        if (sites.length > 0) {
            setClientSelected(true);
        } else {
            setClientSelected(false);
        }
    }, [sites]);

    const handleManufacturer = (manufacturer) => {
        if (manufacturer === defaultManufacturer) {
            return '';
        }

        return manufacturer;
    };

    const handleClientChange = async event => {
        const { value } = event.target;

        formik.setFieldValue('site', '', false);

        formik.setTouched({
            site: false
        });

        setClientSelected(true);

        toggleLoading(false);
        await fetchClientSites(value);

        formik.handleChange(event);
    };

    const fetchEquipmentsOrSystems = async (siteId, isEquipmentCreate) => {
        if (isEquipmentCreate) {
            const systems = await fetchSystemsBySiteId(siteId);
            let systemList = [];
            if (systems) {
                // eslint-disable-next-line array-callback-return
                systems.map(item => {
                    systemList.push(
                        {
                            id:   item.id,
                            name: item.name
                        }
                    );
                });
            }
            setSystems(systemList);
        } else {
            const equipments = await fetchEquipmentsBySiteId(siteId);
            let equipmentList = [];
            if (equipments) {
                // eslint-disable-next-line array-callback-return
                equipments.map(item => {
                    equipmentList.push(
                        {
                            id:   item.id,
                            name: item.name
                        }
                    );
                });
            }
            setEquipments(equipmentList); 
        }
    };

    const handleSiteChange = async event => {
        const { value } = event.target;
        fetchEquipmentsOrSystems(value, isEquipmentCreate);
        toggleLoading(false);
        
        formik.handleChange(event);
    };

    const handleClose = (body) => {
        toggleLoading(false);
        clearErrors();

        setClientSelected(false);
        onClose();
        // fetching Equipment or System
        isEquipmentCreate ? fetchEquipmentListAfterCreate(body.name): fetchSystemListAfterCreate(body.name);
        close();
    };

    const handleRadioChange = (event) => {
        event.preventDefault();
        
        setIsEquipmentCreate(!isEquipmentCreate);
        if (formik.values.site) fetchEquipmentsOrSystems(formik.values.site, !isEquipmentCreate);

    };   
    
    return (
        <React.Fragment>
            { !isEdit ?
                <FormControl component="fieldset" className={classes.formControl}>
                    <RadioGroup
                        row aria-label="create" name="create"
                        value={isEquipmentCreate}
                        onChange={(e) => handleRadioChange(e)}
                    >
                        <FormControlLabel
                            value={true} control={<Radio />} label="Equipment"
                            labelPlacement="start"
                        />
                        <FormControlLabel
                            value={false} control={<Radio />} label="System"
                            labelPlacement="start"
                        />
                    </RadioGroup>
                </FormControl> : '' }
            <div className={classes.formColumn}>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={classes.inputWrapper}>
                            <InputLabel
                                htmlFor="client"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                                error={Boolean(formik.errors.client) && Boolean(formik.touched.client)}
                            >
                                Client<span className={classes.required}> *</span>
                            </InputLabel>
                            <Select
                                value={formik.values.client}
                                onChange={handleClientChange}
                                className={classes.select}
                                disabled={isEdit}
                                inputProps={{
                                    name:   'client',
                                    id:     'client',
                                    onBlur: formik.handleBlur
                                }}
                                error={Boolean(formik.errors.client) && Boolean(formik.touched.client)}
                            >
                                {
                                    navClients.map(type =>
                                        <MenuItem
                                            key={type.id}
                                            value={type.id}
                                        >
                                            {type.name}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                            {formik.touched.client &&
                             formik.errors.client && <FormHelperText className={classes.error}>{formik.errors.client}</FormHelperText>}
                        </FormControl>
                        <FormControl className={classes.inputWrapper}>
                            <InputLabel
                                htmlFor="site"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                                error={Boolean(formik.errors.site) && Boolean(formik.touched.site)}
                            >
                                Site<span className={classes.required}> *</span>
                            </InputLabel>
                            <Select
                                value={formik.values.site}
                                onChange={handleSiteChange}
                                className={classes.select}
                                disabled={!clientSelected || isEdit}
                                inputProps={{
                                    name:   'site',
                                    id:     'site',
                                    onBlur: formik.handleBlur
                                }}
                                error={Boolean(formik.errors.site) && Boolean(formik.touched.site)}
                            >
                                {
                                    sites.map(type =>
                                        <MenuItem
                                            key={type.id}
                                            value={type.id}
                                        >
                                            {type.name}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                            {formik.touched.site &&
                             formik.errors.site && <FormHelperText className={classes.error}>{formik.errors.site}</FormHelperText>}
                        </FormControl>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="name"
                                name="name"
                                type="text"
                                value={formik.values.name}
                                label={isEquipmentCreate ? <span>Equipment Name<span className={classes.required}> *</span></span> : <span>System Name<span className={classes.required}> *</span></span>}
                                onChange={formik.handleChange}
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.name) && Boolean(formik.touched.name)}
                                helperText={Boolean(formik.touched.name) && formik.errors.name}
                            />
                        </FormControl>
                        {
                            isEquipmentCreate ?
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="equipmentType"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                        error={Boolean(formik.errors.equipmentType) && Boolean(formik.touched.equipmentType)}
                                    >
                                        Equipment Type<span className={classes.required}> *</span>
                                    </InputLabel>
                                    <Select
                                        value={formik.values.equipmentType}
                                        onChange={formik.handleChange}
                                        className={classes.select}
                                        inputProps={{
                                            name:   'equipmentType',
                                            id:     'equipmentType',
                                            onBlur: formik.handleBlur
                                        }}
                                        error={Boolean(formik.errors.equipmentType) && Boolean(formik.touched.equipmentType)}
                                    >
                                        {
                                            equipmentTypes.map(type =>
                                                <MenuItem
                                                    key={type.id}
                                                    value={type.id}
                                                >
                                                    {type.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                    {formik.touched.equipmentType &&
                             formik.errors.equipmentType && <FormHelperText className={classes.error}>{formik.errors.equipmentType}</FormHelperText>}
                                </FormControl> :
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="systemType"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                        error={Boolean(formik.errors.systemType) && Boolean(formik.touched.systemType)}
                                    >
                                        System Type<span className={classes.required}> *</span>
                                    </InputLabel>
                                    <Select
                                        value={formik.values.systemType}
                                        onChange={formik.handleChange}
                                        className={classes.select}
                                        inputProps={{
                                            name:   'systemType',
                                            id:     'systemType',
                                            onBlur: formik.handleBlur
                                        }}
                                    >
                                        {
                                            systemTypes.map(type =>
                                                <MenuItem
                                                    key={type.id}
                                                    value={type.id}
                                                >
                                                    {type.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                    {formik.touched.site &&
                             formik.errors.site && <FormHelperText className={classes.error}>{formik.errors.site}</FormHelperText>}
                                </FormControl> }
                        
                        { isEquipmentCreate ?
                            <FormControl className={classes.inputWrapper}>
                                <InputLabel
                                    htmlFor="manufacturer"
                                    classes={{
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }}
                                    error={Boolean(formik.errors.manufacturer) && Boolean(formik.touched.manufacturer)}
                                >
                                    Manufacturer
                                </InputLabel>
                                <Select
                                    value={formik.values.manufacturer}
                                    onChange={formik.handleChange}
                                    className={classes.select}
                                    inputProps={{
                                        name:   'manufacturer',
                                        id:     'manufacturer',
                                        onBlur: formik.handleBlur
                                    }}
                                    error={Boolean(formik.errors.manufacturer) && Boolean(formik.touched.manufacturer)}
                                >
                                    {
                                        manufacturers.map(manufacturer =>
                                            <MenuItem
                                                key={manufacturer.id}
                                                value={manufacturer.id}
                                            >
                                                {manufacturer.name}
                                            </MenuItem>
                                        )
                                    }
                                </Select>
                                {formik.touched.manufacturer &&
                             formik.errors.manufacturer && <FormHelperText className={classes.error}>{formik.errors.manufacturer}</FormHelperText>}
                            </FormControl> : '' }
                        { isEquipmentCreate ?
                            <FormControl className={classes.inputWrapper}>
                                <TextField
                                    id="modelNumber"
                                    name="modelNumber"
                                    type="text"
                                    value={formik.values.modelNumber}
                                    label="Model Number"
                                    onChange={formik.handleChange}
                                    InputLabelProps={{
                                        classes: {
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }
                                    }}
                                    InputProps={{
                                        onBlur:  formik.handleBlur,
                                        classes: {
                                            error:     classes.cssErrorUnderline,
                                            underline: classes.cssUnderline,
                                            root:      classes.input
                                        }
                                    }}
                                    FormHelperTextProps={{
                                        classes: {
                                            error: classes.error
                                        }
                                    }}
                                    error={Boolean(formik.errors.modelNumber) && Boolean(formik.touched.modelNumber)}
                                    helperText={Boolean(formik.touched.modelNumber) && formik.errors.modelNumber}
                                />
                            </FormControl> : '' }
                        { isEquipmentCreate ?
                            <FormControl className={classes.inputWrapper}>
                                <TextField
                                    id="serialNumber"
                                    name="serialNumber"
                                    type="text"
                                    value={formik.values.serialNumber}
                                    label="Serial Number"
                                    onChange={formik.handleChange}
                                    InputLabelProps={{
                                        classes: {
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }
                                    }}
                                    InputProps={{
                                        onBlur:  formik.handleBlur,
                                        classes: {
                                            error:     classes.cssErrorUnderline,
                                            underline: classes.cssUnderline,
                                            root:      classes.input
                                        }
                                    }}
                                    FormHelperTextProps={{
                                        classes: {
                                            error: classes.error
                                        }
                                    }}
                                    error={Boolean(formik.errors.serialNumber) && Boolean(formik.touched.serialNumber)}
                                    helperText={Boolean(formik.touched.serialNumber) && formik.errors.serialNumber}
                                />
                            </FormControl> : '' }
                        { isEdit ? '' :
                            isEquipmentCreate ?
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="systems"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                    >
                                        Associate to System
                                    </InputLabel>
                                    <Select
                                        multiple
                                        value={formik.values.systems}
                                        id="systems"
                                        input={<Input id="select-multiple-checkbox" />}
                                        renderValue={selected => selected.join(', ')}
                                        onChange={formik.handleChange}
                                        name="systems"
                                        className={`${classes.cssUnderline} ${classes.input}`}
                                        inputProps={{
                                            name: 'systems',
                                            id:   'systems',
                                        }}
                                    >
                                        {
                                            systems.map(f => f.name).map((type, index) => (
                                                <MenuItem
                                                    className={classes.selectMenuItem}
                                                    value={type}
                                                    key={index}
                                                >
                                                    <Checkbox
                                                        color="primary"
                                                        checked={formik.values.systems.indexOf(type) > -1}
                                                    />

                                                    <span>{type}</span>
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl> :
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="equipments"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                    >
                                        Associate with Equipment
                                    </InputLabel>
                                    <Select
                                        multiple
                                        value={formik.values.equipments}
                                        id="equipments"
                                        input={<Input id="select-multiple-checkbox" />}
                                        renderValue={selected => selected.join(', ')}
                                        onChange={formik.handleChange}
                                        name="equipments"
                                        className={`${classes.cssUnderline} ${classes.input}`}
                                        inputProps={{
                                            name: 'equipments',
                                            id:   'equipments',
                                        }}
                                    >
                                        {
                                            equipments.map(f => f.name).map((type, index) => (
                                                <MenuItem
                                                    className={classes.selectMenuItem}
                                                    value={type}
                                                    key={index}
                                                >
                                                    <Checkbox
                                                        color="primary"
                                                        checked={formik.values.equipments.indexOf(type) > -1}
                                                    />

                                                    <span>{type}</span>
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>
                        }
                    </div>
                </div>
            </div>
            <React.Fragment>
                <Button
                    className={classes.Button}
                    onClick={onClose}
                    variant="contained"
                >
                    Cancel
                </Button>
                <BobConfirmButton
                    className={classes.ButtonWithMargin}
                    isLoading={isLoading}
                    disabled={formik.isSubmitting || isLoading}
                    label={isEdit ? 'Update' : 'Create'}
                    onClick={formik.handleSubmit}
                />
            </React.Fragment>
            {
                bobLoading.includes('fetchEquipment') || bobLoading.includes('fetchSystem') ?
                    <BobLoadingMask />
                    :
                    null
            }
        </React.Fragment>
    );
};

CreateEquipmentOrSystemModal.defaultProps = {
    clients:        [],
    equipmentTypes: [],
    manufacturers:  [],
    sites:          []
};

CreateEquipmentOrSystemModal.propTypes = {
    clients:        array,
    close:          func,
    equipmentTypes: array,
    manufacturers:  array,
    sites:          array
};

const mapStateToProps = state => {
    return {
        activeNavClient:   state.bob.activeNavClient,
        activeNavSite:     state.bob.activeNavSite,
        bobLoading:        state.bob.bobLoading,
        clients:           state.architect.clientNodes,
        equipmentTypes:    state.equipmentTypes.data,
        errors:            state.messages.errors,
        filteredSystems:   state.architect.filteredSystems,
        filteredEquipment: state.architect.filteredEquipment,
        isLoading:         state.ui.isLoading,
        selectedClient:    state.client.selectedClient,
        selectedSite:      state.site.selectedSite,
        systemTypes:       state.systemTypes.data,
        manufacturers:     state.architect.manufacturers,
        navClients:        state.bob.navClients,
        sites:             state.site.sites,
        targetNavClient:   state.bob.targetNavClient,
        targetNavSite:     state.bob.targetNavSite,
        targetNavCompany:  state.bob.targetNavCompany
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...SiteActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateEquipmentOrSystemModal);
